import { IconProps } from './icons-props';

function ChecvronIcon({ className, width = 9, height = 16 }: IconProps) {
    return (
        <svg
            className={className}
            width={width}
            height={height}
            viewBox='0 0 9 16'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M7.49951 1.2771C7.53536 1.2771 7.56685 1.29073 7.58838 1.31226C7.6097 1.33376 7.62256 1.36449 7.62256 1.40015C7.62253 1.43582 7.60975 1.46655 7.58838 1.48804L2.15479 6.92163C1.55956 7.5169 1.55953 8.48361 2.15479 9.07886L7.58838 14.5115C7.60991 14.533 7.62256 14.5645 7.62256 14.6003C7.62249 14.6327 7.61027 14.6595 7.59229 14.6804C7.55209 14.7153 7.51675 14.7253 7.49951 14.7253C7.4821 14.7253 7.46678 14.7218 7.45361 14.7166C7.44076 14.7114 7.4263 14.7029 7.41162 14.6882L1.97803 9.25464C1.29026 8.56655 1.29009 7.43285 1.97803 6.74487L7.41162 1.31226C7.43307 1.29081 7.46383 1.2772 7.49951 1.2771Z'
                fill='currentColor'
                stroke='currentColor'
            />
        </svg>
    );
}

export default ChecvronIcon;

